import React, { useContext, useReducer, useEffect } from 'react';
import { produce } from 'immer';

import AppContext from '../../../context';
import TopGainersLosers from './top_gainers_losers.component';
import { RadioGroup } from '../../common/common';

const reducer = produce((state, newState) => {
  const { field, value } = newState;
  switch (field) {
    case 'portfolioId':
      state[field] = value;
      break;

    case 'data':
    case 'error':
    case 'isLoaderVisible':
      state[state.portfolioId][field] = value;
      break;

    case 'resetPfData':
      //pfId as value
      const componentState = {
        data: null,
        isLoaderVisible: true,
        error: '',
      };
      state[value.resetId] = { ...componentState };
      state.family = { ...componentState };
      state.portfolioId = value.switchId || value.resetId;
      break;

    default:
      break;
  }
});

const TopGainersLosersWrapper = () => {
  const context = useContext(AppContext);

  //--sample state--
  // {
  //   portfolioId: '123',
  //   123: {
  //     data: [],
  //     isLoaderVisible: true,
  //     error: ''
  //   },
  // }
  //

  const [state, dispatch] = useReducer(reducer, {}, () => {
    const componentState = {
      data: null,
      isLoaderVisible: true,
      error: '',
    };

    const initialState = {};
    context.portfolios.forEach((pf) => {
      return (initialState[pf.id] = { ...componentState });
    });
    //default portfolio - family or first
    initialState.portfolioId =
      context.portfolios.filter(
        (pf) => !pf.is_dummy && !pf.is_empty && pf.id !== 'family',
      ).length > 1
        ? context.portfolios[0].id
        : context.portfolios[1].id;
    return initialState;
  });

  useEffect(() => {
    if (context.resetPf.resetId)
      dispatch({ field: 'resetPfData', value: context.resetPf });
  }, [context.resetPf]);

  return (
    <>
      <div className="content_header">
        <h6 className="content-head">
          Top <span className="desktop">Gainers & Losers</span>
          <span className="mobile">Performers</span>
        </h6>
        <RadioGroup
          name="top-gainers-losers"
          checked={state.portfolioId}
          setChecked={(pfId) => dispatch({ field: 'portfolioId', value: pfId })}
        />
      </div>
      <TopGainersLosers
        portfolioId={state.portfolioId}
        state={state[state.portfolioId]}
        setState={(field, value) => dispatch({ field, value })}
      />
      {/* <p className="disclaimer-text mt-2">*Includes stocks in ETFs</p> */}
    </>
  );
};

export default TopGainersLosersWrapper;
